import type { Ref } from "vue";

const useISOCode = () => {
	const runtimeConfig = useRuntimeConfig();
	const cookie = useCookie("DEV--country");

	const countryISOCode: Ref<string | null> = ref(null);
	const brandUrl: Ref<string | null> = ref(null);

	if (process.server) {
		brandUrl.value = (useNuxtApp().ssrContext?.event.node.req.headers["x-original-host"] as string) ?? null;
	}

	if (process.client) {
		brandUrl.value = useRequestURL().host ?? null;
	}

	if (runtimeConfig.public.env === "development" && cookie.value) {
		countryISOCode.value = cookie.value;
	} else {
		countryISOCode.value =
			brandUrl.value === null || brandUrl.value.includes("localhost") ? runtimeConfig.public.defaultCountry : brandUrl.value.slice(-2).toUpperCase();
	}
	return {
		countryISOCode,
	};
};

export default useISOCode;
